import React from 'react';
import withIcon from '../utilities/withIcon';

const IconGridCircles = () => {
  return (
    <g>
      <path d="M13.5 11a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zm-11 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM8 11a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zm5.5 1.667a.833.833 0 1 0 0 1.666.833.833 0 0 0 0-1.666zm-11 0a.833.833 0 1 0 0 1.666.833.833 0 0 0 0-1.666zm5.5 0a.833.833 0 1 0 0 1.666.833.833 0 0 0 0-1.666zM2.5 5.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zm11 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM8 5.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM2.5 7.167a.833.833 0 1 0 0 1.666.833.833 0 0 0 0-1.666zm11 0a.833.833 0 1 0 0 1.666.833.833 0 0 0 0-1.666zm-5.5 0a.833.833 0 1 0 0 1.666.833.833 0 0 0 0-1.666zM2.5 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zm11 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM8 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM2.5 1.667a.833.833 0 1 0 0 1.666.833.833 0 0 0 0-1.666zm11 0a.833.833 0 1 0 0 1.666.833.833 0 0 0 0-1.666zm-5.5 0a.833.833 0 1 0 0 1.666.833.833 0 0 0 0-1.666z" />
    </g>
  );
};

export default withIcon(IconGridCircles);
